import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { userSchema } from '../schemas/user.schema';

const requestSchema = z.array(
  userSchema
    .omit({
      id: true,
      assignments: true,
    })
    .partial()
    .required({
      externalId: true,
    })
    .extend({ externalName: z.string().min(1) })
);

/**
 * Create multiple Users
 * @param request An array of Users to create (only externalId is required for each User)
 * @returns A data object indicating success along with an array for error details
 */
export function postAmsuiUsersImport(
  this: unknown,
  request: z.infer<typeof requestSchema>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${accountsEnvironment.resolve(this).amsuiUsersUrl}/import`, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
            ? new AuthHeaders()
            : jwtAuthHeaders),
        },
        body: JSON.stringify(request),
      })
    )
  ).pipe(
    selectData(
      z.object({
        success: z.boolean(),
        errorDetails: z.array(
          z.object({
            errorCode: z.number(),
            externalIds: z.array(z.string()),
          })
        ),
      })
    )
  );
}
